import _Object$keys from 'babel-runtime/core-js/object/keys';
import _ from 'lodash';
import { contentTypes } from './step-constants';
import { getConfig } from '../gaia-data/init';

var extractTextObjects = function extractTextObjects(contentArray, outputArray) {
  contentArray.forEach(function (contentItem) {
    if (Array.isArray(contentItem)) {
      extractTextObjects(contentItem, outputArray);
    } else if (contentItem.type !== 'example') {
      if (contentItem.hasOwnProperty(contentTypes.TEXT)) {
        outputArray.push(contentItem.text);
      }
      if (contentItem.hasOwnProperty(contentTypes.HTML_TEXT)) {
        outputArray.push(contentItem.htmlText);
      }
    }
  });
};

// text is special because unlike the others (audios, videos) which
//  have an array of members, text is an object with a
//  single text member - but the content block may have an array of such objects
//  NOTE that this method will always return an array, which can be empty
var getTextsFromContent = function getTextsFromContent(content) {
  var textsArray = [];
  extractTextObjects([content], textsArray);
  return textsArray;
};

function parseContentByType(type, content) {
  if (type === contentTypes.TEXT) {
    return getTextsFromContent(content);
  }
  if (typeof content === 'object' && content.hasOwnProperty(type)) {
    return content[type];
  }
  if (Array.isArray(content)) {
    var filtered = content.filter(function (obj) {
      return obj.hasOwnProperty(type);
    }).map(function (obj) {
      return obj[type];
    });
    return filtered.length ? _.flatten(filtered) : undefined;
  }
}

function getContentTypes(_ref) {
  var audios = _ref.audios,
      images = _ref.images,
      videos = _ref.videos,
      text = _ref.text,
      htmlText = _ref.htmlText;

  var types = [];
  if (audios && audios.length) {
    types.push(contentTypes.AUDIOS);
  }
  if (images && images.length) {
    types.push(contentTypes.IMAGES);
  }
  if (videos && videos.length) {
    types.push(contentTypes.VIDEOS);
  }
  if (text && text.length) {
    types.push(contentTypes.TEXT);
  }
  if (htmlText && htmlText.length) {
    types.push(contentTypes.HTML_TEXT);
  }
  return types;
}

function getContent(content, type) {
  return content.find(function (obj) {
    return obj.hasOwnProperty(type);
  });
}

var isCarouselStep = function isCarouselStep(step) {
  return !!step && Array.isArray(step.content) && !!step.content[0] && Array.isArray(step.content[0].carousel) && step.content[0].carousel.length > 0;
};

// a carousel is an array of section(s), which are arrays of items of various types
var getCarouselSection = function getCarouselSection(step, sectionNdx) {
  if (stepModel.isCarouselStep(step)) {
    return step.content[0].carousel[sectionNdx];
  }
  return null;
};

var getEvaluationType = function getEvaluationType(step) {
  return _.get(step, 'behavior.evaluationType');
};

var isReady = function isReady(step, values) {
  var correctCount = step.correct.length;
  if (Array.isArray(values)) {
    // In some cases, user may select more answers than there is correct.
    return values.length >= correctCount && !_.some(values, _.isEmpty);
  }
  // Same logic as with array
  return _Object$keys(values).length >= correctCount;
};

var isRandomOrdering = function isRandomOrdering(step) {
  var ordering = void 0;
  if (step && step.behavior) {
    ordering = step.behavior.ordering;
  }
  // No ordering means random ordering!
  return !ordering || ordering === 'random';
};

// Check the environment to see if it needs activity choices to be shuffled.
var environmentNeedsShuffledChoices = function environmentNeedsShuffledChoices() {
  var isDev = getConfig().serverUrl && getConfig().serverUrl.includes('-dev.dev');
  var isProd = getConfig().prod;
  return isDev || isProd;
};

// Shuffle choices, suppress in QA environments for snapshot tests.
function shuffleChoices(choices, forceShuffle) {
  if (!forceShuffle && !environmentNeedsShuffledChoices()) {
    return choices;
  }
  return _.shuffle(choices);
}

var areAnswersCorrect = function areAnswersCorrect(step, answers) {
  return answers.every(function (a) {
    return a.correct;
  }) && answers.filter(function (a) {
    return a.correct;
  }).length === step.correct.length;
};

function getInputType(step) {
  return _.get(step, 'behavior.inputType');
}

function getPostprocessNode(step, player) {
  var correct = step.correct,
      postProcess = step.postProcess;
  var showAnswers = player.showAnswers,
      _player$values = player.values,
      values = _player$values === undefined ? [] : _player$values;

  if (!postProcess || !postProcess.successResponses) {
    return null;
  }
  // This assumes input type is radio
  var responseId = showAnswers ? correct[0] : values[0];
  return postProcess.successResponses.find(function (node) {
    return node.responseId === responseId;
  });
}

export var stepModel = {
  environmentNeedsShuffledChoices: environmentNeedsShuffledChoices,
  getTextsFromContent: getTextsFromContent,
  parseContentByType: parseContentByType,
  getContentTypes: getContentTypes,
  getContent: getContent,
  getEvaluationType: getEvaluationType,
  isCarouselStep: isCarouselStep,
  getCarouselSection: getCarouselSection,
  isReady: isReady,
  isRandomOrdering: isRandomOrdering,
  shuffleChoices: shuffleChoices,
  areAnswersCorrect: areAnswersCorrect,
  getInputType: getInputType,
  getPostprocessNode: getPostprocessNode
};